import { active } from "@api/stores/productCategories/active/path";
import { deactive } from "@api/stores/productCategories/deactive/path";
import { stats } from "@api/stores/productCategories/stats/path";
import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/product-categories/`;
const pathById = `${pathBase}:productCategoryId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const productCategories = {
  get: apiPathFunc(pathById),
  getAll: apiPathFunc(pathBase),
  post: apiPathFunc(pathBase),
  patch: apiPathFunc(pathById),
  active,
  deactive,
  stats,
};
